import React from "react";
import { connect } from "react-redux";

import Snackbar from "@material-ui/core/Snackbar";

import { clearSnackbarMessage } from "../../store/actionCreators/snackbarMessage";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";

class alertPopup extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      show: false
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.message !== "") {
      this.setState({ show: true });
      setTimeout(() => {
        this.handleClose();
      }, 5000);
    }
  }

  handleClose = () => {
    this.setState({ show: false });
    this.props.closeSnackbar();
  };

  render() {
    const { show } = this.state;
    const { message } = this.props;
    return (
      <Snackbar
        open={show}
        onClose={this.handleClose}
        ContentProps={{
          "aria-describedby": "message-id"
        }}
        message={<span id="message-id">{message}</span>}
        action={[
          <IconButton
            key="close"
            aria-label="Close"
            color="inherit"
            onClick={this.handleClose}
          >
            <CloseIcon />
          </IconButton>
        ]}
      />
    );
  }
}

const mapStateToProps = state => {
  return {
    message: state.snackbarMessage
  };
};

const mapDispatchToProps = dispatch => {
  return {
    closeSnackbar: () => {
      dispatch(clearSnackbarMessage());
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(alertPopup);



// WEBPACK FOOTER //
// ./src/components/Utils/Notification.js